import {MultiSelectorItem} from '../components/multi-selector/multi-selector-item';

export class Category1 implements MultiSelectorItem {
  public static fromJson({ uid, name, desc }): Category1 {
    return new Category1(uid, name, desc);
  }
  constructor(public uid: string, public name: string, public desc: string) {}

  public getId(): string {
    return this.uid;
  }

  public getDisplayText(): string {
    return this.name;
  }
  public getDescription(): string {
    return this.desc;
  }
}
